// extracted by mini-css-extract-plugin
module.exports = {"sortCriteria":"DatabaseListItem_sortCriteria__2TSsO","pageNavi":"DatabaseListItem_pageNavi__2mZ3Q","pageNaviItem":"DatabaseListItem_pageNaviItem__3ztvf"};